import { useEffect, useRef, useState } from "react";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import { Modal, InputGroup } from "react-bootstrap";
import http from "../../common/http-common";
import * as common from "../../common/common";
import * as Comp from "../../common/CommonComponents";
// import classes from "../Styles/common.module.css";
import save from "../../assets/save-icon.png";
import cancel from "../../assets/cancel-icon.png";

const SystemInfoRegister = (props) => {
    const [cookies] = useCookies([]);
    const [userId] = useState(cookies.USER_ID);

    const systemInputRef = useRef();
    const remarkInputRef = useRef();

    //For company and system list
    const [companyList, setCompanyList] = useState([]);
    const [selectedCompany, setSelectedCompany] = useState(null);

    const [systemList, setSystemList] = useState([]);
    const [selectedSystem, setSelectedSystem] = useState(null);

    //For System ENV,Type Dropdown
    const [selectedEnv, setSelectedEnv] = useState(null);
    const [selectedConn, setSelectedConn] = useState(null);

    const [ConnTypeListToBeSelect, setConnTypeListToBeSelect] = useState([]);
    const [ConnList, setConnList] = useState([]);

    const [EnvListToBeSelect, setEnvListToBeSelect] = useState([]);
    const [EnvList, setEnvList] = useState([]);

    const [addData, setAddData] = useState({});
    const [inputError, setInputError] = useState({});

    // useEffect(() => {
    //     if (props.showHide) {
    //         fetchEnvOptions();
    //         fetchTypeOptions();
    //     }
    // }, [props.showHide]);

    const hideModal = () => {
        setEnvList([]);
        setConnList([]);
        setAddData([]);
        setInputError([]);
        //setCompanyList ([]);
        setSelectedCompany([]);
        setSystemList([]);
        setSelectedSystem([]);
        setSelectedEnv([]);
        setSelectedConn([]);
        props.onHide();
    };

    useEffect(() => {
        let functionName = "";
        try {
            functionName = "Get Company List";
            http
                .get("api/SystemInfo/GetCompanyList?_user=" + userId, { timeout: 10000 })
                .then((response) => {
                    const companies = response.data.map((item) => ({
                        key: item.ORG_ID,
                        value: item.ORG_ID,
                        label: item.ORG_NAME,
                    }));
                    setCompanyList(companies);
                })
                .catch((err) => {
                    common.c_LogWebError(props.page, functionName, err);
                });
        } catch (err) {
            common.c_LogWebError(props.page, functionName, err);
        }
    }, []);

    const onCompanyChange = (val) => {
        setSelectedCompany(val);
        setSelectedSystem(null); // clear previous selection
        if (val?.value) {
            let functionName = "";
            try {
                functionName = "Get System List";
                http
                    .get(`api/SystemInfo/GetSystemList?_user=${userId}&_orgId=${val.value}`, { timeout: 10000 })
                    .then((response) => {
                        const systems = response.data.map((item) => ({
                            key: item.SYSTEM_MST_ID,
                            value: item.SYSTEM_MST_ID,
                            label: item.SYSTEM_MST_NAME,
                        }));
                        setSystemList(systems);
                    })
                    .catch((err) => {
                        common.c_LogWebError(props.page, functionName, err);
                    });
            } catch (err) {
                common.c_LogWebError(props.page, functionName, err);
            }
        }
    };

    useEffect(() => {
        let functionName = "";
        try {
          functionName = "Get ENV List";
          http
            .get("api/SystemInfo/GetEnvList?_user=" + userId)
            .then((response) => {
              const EnvList = [];
              for (var i = 0; i < response.data.length; i++) {
                EnvList.push({
                  key: response.data[i].SERVER_ENV_ID,
                  value: response.data[i].SERVER_ENV_ID,
                  label: response.data[i].SERVER_ENV_NAME,
                });
              }
              setEnvListToBeSelect(EnvList);
            })
            .catch((err) => {
              common.c_LogWebError(props.page, functionName, err);
            });
        } catch (err) {
          common.c_LogWebError(props.page, functionName, err);
        }
      }, []);


      useEffect(() => {
        let functionName = "";
        try {
          functionName = "Get Conn List";
          http
            .get("api/SystemInfo/GetConnTypeList?_user=" + userId)
            .then((response) => {
              const ConnList = [];
              for (var i = 0; i < response.data.length; i++) {
                ConnList.push({
                  key: response.data[i].SERVER_CONN_TYPE_ID,
                  value: response.data[i].SERVER_CONN_TYPE_ID,
                  label: response.data[i].SERVER_CONN_TYPE_NAME,
                });
              }
              setConnTypeListToBeSelect(ConnList);
            })
            .catch((err) => {
              common.c_LogWebError(props.page, functionName, err);
            });
        } catch (err) {
          common.c_LogWebError(props.page, functionName, err);
        }
      }, []);


    const saveBtnOnClick = () => {
        var flag = true;
        setInputError({});
        const errors = {};

        if (!selectedCompany) {
            flag = false;
            errors.ORG_ID = "Company selection is required.";
        }

        if (!selectedSystem) {
            flag = false;
            errors.SYSTEM_MST_ID = "System selection is required.";
        }

        if (!selectedEnv) {
            flag = false;
            errors.SERVER_ENV_NAME = "System environment could not be empty.";
        }

        if (!selectedConn) {
            flag = false;
            errors.SERVER_CONN_TYPE_NAME = "Server type could not be empty.";
        }

        // Validate IP or URL — at least one must be filled
        if (!(addData.IP_ADDRESS || '').trim() && !(addData.URL || '').trim()) {
          flag = false;
          errors.IP_ADDRESS = "Either IP or URL must be provided.";
          errors.URL = "Either IP or URL must be provided.";
        }

        if (!addData.ID) {
            flag = false;
            errors.ID = "ID is required.";
        }

        if (!addData.PASSWORD) {
            flag = false;
            errors.PASSWORD = "Password is required.";
        }

        setInputError(errors);

        if (
        Object.values(errors).filter((v) => v !== "").length === 0 &&
        flag
        ) {
        SystemInfoRegister();
        }
    };


    function SystemInfoRegister() {
        let functionName = "";
        try {
            functionName = props.page + SystemInfoRegister.name;
            props.onLoading(true, "Registering system, please wait...");
            const selectedEnvID = selectedEnv?.value;
            const selectedConnID = selectedConn?.value;

            //const selectedEnvID = 'A781A9AF-3E71-4DCF-8420-DCD95D1E6847';
            //const selectedConnID = '43102C61-0179-4449-933D-1712E65E4A75';
            
            const data = {
                ORG_ID: selectedCompany?.value,
                ORG_NAME: selectedCompany?.label,
                SYSTEM_MST_ID: selectedSystem?.value,
                SYSTEM_MST_NAME: selectedSystem?.label,
                //SERVER_ENV_NAME: addData.SERVER_ENV_NAME;
                //SERVER_CONN_TYPE_NAME: selectedType?.SERVER_CONN_TYPE_NAME || "",
                SERVER_ENV_ID: selectedEnvID,
                SERVER_CONN_TYPE_ID: selectedConnID,
                IP_ADDRESS: addData.IP_ADDRESS,
                URL:addData.URL,
                ID: addData.ID,
                PASSWORD: addData.PASSWORD,
                DB_SID: addData.DB_SID || "",
                REMARK: addData.REMARK || "",
                UPDATE_ID: userId,
                FROM_SOURCE: { SOURCE: "WEB", MODULE_ID: props.module },

            };

            //console.log(data); //test
            //console.log(ConnList); //test

            http
                .post("api/SystemInfo/RegisterSys", data, { timeout: 10000 })
                .then((response) => {
                    if (response.data.DUPLICATE_SYSTEM_MST_NAME === true) {
                        toast.error("System already exist.");
                    } else {
                        toast.success("System is successfully inserted.");
                        props.onReload();
                        hideModal();
                    }
                })
                .catch((err) => {
                    toast.error("Failed to insert System. Please try again.");
                    //console.error("System Insert Error:", err?.response || err); //tEST
                    common.c_LogWebError(props.page, functionName, err);
                })
                .finally(() => {
                    props.onLoading(false, "Loading...");
                });
        } catch (err) {
            props.onLoading(false, "Loading...");
            toast.error("Failed to insert System. Please try again.");
            common.c_LogWebError(props.page, functionName, err);
        }
    };

    const inputRequiredHandler = (event) => {
        let functionName = "";

        try {
            functionName = inputRequiredHandler.name;
            const name = event.target.name;
            functionName = inputRequiredHandler.name + "_" + name;
            const id = event.target.id;
            const val = event.target.value;
            //if (val.length === 0 || val.trim().length === 0) {
                if (val.length === 0) {
                setInputError((prevState) => ({
                    ...prevState,
                    [id]: (name + " could not be empty."),
                }));
            } else {
                setInputError((prevState) => ({
                    ...prevState,
                    [id]: (""),
                }));
            }
            setAddData((prevState) => ({
                ...prevState,
                [id]: val,
            }));
        } catch (err) {
            common.c_LogWebError(props.page, functionName, err);
        }
    };

    const selectEnvListHandler = (val) => {
            let functionName = "";
        
            try {
              functionName = selectEnvListHandler.name;
              if (Object.keys(val).length > 0) {
                setInputError((prevState) => ({
                  ...prevState,
                  SERVER_ENV_NAME: "",
                }));
              } else {
                setInputError((prevState) => ({
                  ...prevState,
                  SERVER_ENV_NAME: "Server Environment could not be empty.",
                }));
              }
              setEnvList([...val]);
            } catch (err) {
              common.c_LogWebError(props.page, functionName, err);
            }
          };


    const selectConnListHandler = (val) => {
            let functionName = "";
        
            try {
              functionName = selectConnListHandler.name;
              if (Object.keys(val).length > 0) {
                setInputError((prevState) => ({
                  ...prevState,
                  SERVER_CONN_TYPE_NAME: "",
                }));
              } else {
                setInputError((prevState) => ({
                  ...prevState,
                  SERVER_CONN_TYPE_NAME: "Server Environment could not be empty.",
                }));
              }
              setConnList([...val]);
            } catch (err) {
              common.c_LogWebError(props.page, functionName, err);
            }
          };

    const inputUnrequiredHandler = (event) => {
        let functionName = "";

        try {
            functionName = inputUnrequiredHandler.name;
            const name = event.target.name;
            functionName = inputUnrequiredHandler.name + "_" + name;
            const id = event.target.id;
            const val = event.target.value;

            setAddData((prevState) => ({
                ...prevState,
                [id]: val,
            }));
        } catch (err) {
            common.c_LogWebError(props.page, functionName, err);
        }
    };

    const selectionHandler = (val, field) => {
            let functionName = "";
        
            try {
              functionName = selectionHandler.name;
              setInputError((prevState) => ({
                ...prevState,
                [field]: "",
              }));
              setAddData((prevState) => ({
                ...prevState,
                [field]: val, //Document type
              }));
            } catch (err) {
              common.c_LogWebError(props.page, functionName, err);
            }
          };

    return (
        <>
            <Modal show={props.showHide} onHide={hideModal} centered>
                <Modal.Header>
                    <div style={{ backgroundColor: "lightgrey", width: "100%" }}>
                        <Modal.Title>REGISTER</Modal.Title>
                    </div>
                </Modal.Header>
                <Modal.Body>
                    <Comp.Select
                        id="ORG_ID"
                        label="Company*:"
                        type="text"
                        options={companyList}
                        closeMenuOnSelect={true}
                        isClearable={true}
                        hideSelectedOptions={false}
                        errorMessage={inputError.ORG_ID}
                        value={selectedCompany}
                        onChange={onCompanyChange}
                        autoComplete="off"
                    />

                    <Comp.Select
                        id="SYSTEM_MST_ID"
                        label="System Name*:"
                        type="text"
                        options={systemList}
                        closeMenuOnSelect={true}
                        isClearable={true}
                        hideSelectedOptions={false}
                        errorMessage={inputError.SYSTEM_MST_ID}
                        value={selectedSystem}
                        onChange={(val) => setSelectedSystem(val)}
                        autoComplete="off"
                    />

                    <Comp.Select
                        id="SERVER_ENV_ID"
                        label="Prod. / Dev.*:"
                        type="text"
                        options={EnvListToBeSelect}
                        closeMenuOnSelect={true}
                        isClearable={true}
                        hideSelectedOptions={false}
                        errorMessage={inputError.SERVER_ENV_NAME}
                        value={selectedEnv}
                        onChange={(val) => setSelectedEnv(val)}
                        autoComplete="off"
                    />

                     <Comp.Select
                        id="SERVER_CONN_TYPE_ID"
                        label="Server Type*:"
                        type="text"
                        options={ConnTypeListToBeSelect}
                        closeMenuOnSelect={true}
                        isClearable={true}
                        hideSelectedOptions={false}
                        errorMessage={inputError.SERVER_CONN_TYPE_NAME}
                        value={selectedConn}
                        onChange={(val) => setSelectedConn(val)}
                        autoComplete="off"
                    />
                    
                    <Comp.Input
                        id="IP_ADDRESS"
                        label="IP:"
                        name="IP"
                        type="text"
                        className="form-control"
                        errorMessage={inputError.IP_ADDRESS}
                        value={addData.IP_ADDRESS || ""}
                        onChange={inputUnrequiredHandler}
                    />

                    <Comp.Input
                        id="URL"
                        label="URL:"
                        name="URL"
                        type="text"
                        className="form-control"
                        errorMessage={inputError.URL}
                        value={addData.URL || ""}
                        onChange={inputUnrequiredHandler}
                    />

                    <Comp.Input
                        id="ID"
                        label="ID*:"
                        name="ID"
                        type="text"
                        className="form-control"
                        errorMessage={inputError.ID}
                        value={addData.ID || ""}
                        onChange={inputRequiredHandler}
                    />

                    <Comp.Input
                        id="PASSWORD"
                        label="Password*:"
                        name="Password"
                        type="password"
                        className="form-control"
                        errorMessage={inputError.PASSWORD}
                        value={addData.PASSWORD || ""}
                        onChange={inputRequiredHandler}
                    />

                    <Comp.Input
                        id="DB_SID"
                        label="DB SID:"
                        name="DB SID"
                        type="text"
                        className="form-control"
                        value={addData.DB_SID || ""}
                        onChange={inputUnrequiredHandler}
                    />

                    <Comp.Input
                    ref={remarkInputRef}
                    id="REMARK"
                    label="Remark:"
                    type="text"
                    className="form-control"
                    value={addData.REMARK || ""}
                    onChange={inputUnrequiredHandler}
                    />

                </Modal.Body>
                <Modal.Footer>
                    <div style={{ textAlign: "center", width: "100%" }}>
                        <Comp.Button id="btnSave" onClick={saveBtnOnClick}>
                            Save  <img src={save} alt="Save" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "3px" }} />
                        </Comp.Button>
                        &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
                        <Comp.Button
                            id="btnCancel"
                            type="cancel"
                            onClick={hideModal}
                        >
                            Cancel  <img src={cancel} alt="Cancel" style={{ width: "16px", height: "16px", marginLeft: "2px", marginBottom: "3px" }} />
                        </Comp.Button>
                    </div>
                </Modal.Footer>
            </Modal>
        </>
    );
};

export default SystemInfoRegister;